import React, { useCallback, useRef } from 'react';
import classNames from 'classnames';
import loadable from '@loadable/component';
import useBvReviewsForceMount from './BazaarVoice/useBvReviewsForceMount';
import BVReviewsHost from './BazaarVoice/BVReviewsHost';
import usePdpFullVariantSku from './state/pdpFullVariantSku/usePdpFullVariantSku';
import PDPDeferredSection from './PDPDeferredSection';
const PDPCustomerPhotos = loadable(() => import('./PDPCustomerPhotos'));
const BVReviewsOnShowHost = loadable(() => import('./BazaarVoice/BVReviewsOnShowHost'));
const PDPDeferredReviews = ({
  isLayoutRevamp = false,
  isEditOrder = false
}) => {
  const containerRef = useRef(null);
  const eagerHostRef = useRef(null);
  const deferredHostRef = useRef(null);
  const forceMountReviews = useBvReviewsForceMount();
  const variantSku = usePdpFullVariantSku();
  const onOwnHost = useCallback(node => {
    deferredHostRef.current = node;
  }, []);
  if (isEditOrder && !forceMountReviews) return null;

  // Read during render so the show handler's flushSync can commit a host in
  // this same turn. If the deferred chunk already owns one, keep that node.
  const showEagerHost = Boolean(forceMountReviews && variantSku && !deferredHostRef.current);
  return <div ref={containerRef} id="PDPCustomerPhotos" role="region" aria-label="Customer reviews" data-xc="PDPDeferredReviews" className={classNames('min-h-[400px]', {
    '[border-top:1px_solid_#e5e5e5] mt-14 pt-14': !isLayoutRevamp,
    'mt-0 pt-0': isLayoutRevamp
  })}>
      {showEagerHost && <BVReviewsHost key={variantSku} productId={variantSku} hostRef={eagerHostRef} />}
      <PDPDeferredSection>
        {isEditOrder ? <BVReviewsOnShowHost forceMountReviews={forceMountReviews} reviewsHostRef={showEagerHost ? eagerHostRef : null} onOwnHost={onOwnHost} /> : <PDPCustomerPhotos containerRef={containerRef} forceMountReviews={forceMountReviews} reviewsHostRef={showEagerHost ? eagerHostRef : null} onOwnHost={onOwnHost} />}
      </PDPDeferredSection>
    </div>;
};
export default PDPDeferredReviews;